import { Box, Button, Typography } from '@mui/material';
import { MAIN_THEME_COLOR } from '../assets/theme/Colors';

interface LimitAlertProps {
	handleActionButtonClick: () => void;
	content: string;
}

function SmallLimitationAlert({
	handleActionButtonClick,
	content,
}: LimitAlertProps) {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				backgroundColor: '#FFF4E5',
				paddingY: '6px',
				paddingX: '10px',
				alignItems: 'center',
				justifyContent: 'space-between',
			}}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					marginX: '10px',
				}}>
				<Typography variant="body2" sx={{ color: '#78350F' }}>
					{`⚠️ ${content} `}
				</Typography>
			</Box>
			<Button
				onClick={handleActionButtonClick}
				style={{
					boxShadow: 'none',
					textTransform: 'none',
					color: MAIN_THEME_COLOR,
					backgroundColor: '#FFFFFF',
					marginLeft: '10px',
				}}
				variant="contained">
				Resolve
			</Button>
		</Box>
	);
}

export default SmallLimitationAlert;
